<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col lg="12">
        <b-card
          title="Récapitulation des mandats non respectés dont l'email est connu"
          class="bg-light shadow"
          title-tag="h6"
        >
          <div class="card-body" v-if="loaded">
            <b-button @click="sendEmails()" size="sm" variant="secondary"><b-icon-envelope-fill class="mr-2"></b-icon-envelope-fill> Envoyer les emails</b-button>
            <b-alert class="mt-3" v-if="errors_msg" v-html="errors_msg" show variant="danger"></b-alert>
            <div class="mt-3" v-html="rappels"></div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import gestion from "@/services/gestion.js";
export default {
  name: "ManageSettlementsInDefaultEmail",
  components: {},
  data() {
    return {
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Mandats dont l'arrangement n'est pas respecté",
          to: { name: "manageSettlementsInDefault"},
        },
        {
          text: "Récapitulif emails",
          active: true,
        },
      ],
      rappels: {},
      busy: false,
      errors_msg: '',
      loaded: false,
    };
  },
  created() {
    this.load();
   
  },
  methods: {
    load() {
      this.busy = true;
      gestion.rappels_emails().then((response) => {
        this.rappels = response.data;
        this.busy = false;
        this.loaded = true;
      });
    },
    sendEmails() {
      this.busy = true;
      gestion.send_emails().then((response) => {
        if(response.data.success) {
          if(response.data.errors.length) {
            this.errors_msg = response.data.errors.join('<br/>');
          }
        }
        this.load();
        this.busy = false;
      });
    },
    completeName(item) {
      let a = "";
      if (item.nom_soc) {
        a += item.nom_soc;
      }
      if (item.nom && item.nom_soc) {
        a += " (" + item.prenom + " " + item.nom + ")";
      } else if (!item.nom_soc) {
        a += item.prenom + " " + item.nom;
      }
      return a;
    },
    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>